import React from 'react';
import { injectIntl } from 'react-intl';

import styles from './InfoBanner.module.scss';
import { WmButton } from '@watermarkinsights/ripple-react';

export default injectIntl(function({
	canClose = false,
	children,
	closeI18n,
	intl,
	onClose,
}) {
	return (
		<div className={styles.container}>
			<div>{children}</div>
			{canClose && (
				<div className={styles.close}>
					<WmButton
						buttonType="navigational"
						icon="f156"
						onClick={onClose}
						tooltip={intl.formatMessage({ id: closeI18n })}
					/>
				</div>
			)}
		</div>
	);
});
